export default __webpack_public_path__ + "static/media/forward-circle-arrow.aa7eb4d0.svg";